import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ChargingStationLocationService } from '../../../shared/services/charging-station-location.service';
import { SnackbarService, FeedbackInfoComponent } from 'ok-angular-shared/components';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { ErrorMessage } from '../../../shared/models/errorMessage.model';
import { AccessGroupService } from '../../../shared/services/access-group.service';
import { AccessGroup, AccessGroupSearchEvent } from '../../access-groups/access-group.model';
import { PageEvent } from '@angular/material/paginator';
import { map, Observable } from 'rxjs';
import { CustomDropDownArrowDirective } from 'ok-angular-shared/directives';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption } from '@angular/material/core';
import { MatButton } from '@angular/material/button';
import { MatSelect } from '@angular/material/select';
import { AsyncPipe } from '@angular/common';

export interface UpdateAccessGroupsAllConnectorsModalData {
  chargingStationLocationIdentifier: string;
  chargingStationLocationName: string;
  organizationId: number;
  numberOfChargingStationLocations: number;
}

@Component({
  selector: 'adm-chargin-station-location-update-access-groups-all-connecctors',
  templateUrl: './charging-station-location-update-access-groups-all-connectors.component.html',
  styleUrl: './charging-station-location-update-access-groups-all-connectors.component.scss',
  imports: [
    CustomDropDownArrowDirective,
    FeedbackInfoComponent,
    MatIcon,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatFormField,
    MatLabel,
    MatButton,
    MatOption,
    MatSelect,
    MatDialogActions,
    ReactiveFormsModule,
    AsyncPipe,
  ],
})
export class ChargingStationLocationUpdateAccessGroupsAllConnectorsComponent implements OnInit {
  private chargingStationLocationService = inject(ChargingStationLocationService);
  private snackbarService = inject(SnackbarService);
  private accessGroupService = inject(AccessGroupService);
  dialogRef = inject<MatDialogRef<ChargingStationLocationUpdateAccessGroupsAllConnectorsComponent>>(MatDialogRef);
  data = inject<UpdateAccessGroupsAllConnectorsModalData>(MAT_DIALOG_DATA);

  public accessGroups$: Observable<AccessGroup[]>;

  public form = new FormGroup({
    accessGroupIdentifiers: new FormControl<string[]>([], { nonNullable: true }),
  });

  ngOnInit(): void {
    const pageEvent = new PageEvent();
    pageEvent.pageSize = 1000;
    const searchEvent = new AccessGroupSearchEvent(pageEvent);
    searchEvent.organizationId = this.data.organizationId;
    this.accessGroups$ = this.accessGroupService.getAccessGroups(searchEvent).pipe(map(pagedResult => pagedResult.items));
  }

  async updateAccessGroups() {
    this.chargingStationLocationService
      .updateAccessGroupsOnChargingStationLocationConnectors({
        chargingStationLocationIdentifier: this.data.chargingStationLocationIdentifier,
        accessGroupIdentifiers: this.form.getRawValue().accessGroupIdentifiers,
      })
      .subscribe({
        error: (error: HttpErrorResponse) => {
          if (error.status == HttpStatusCode.BadRequest && error.error) {
            const errorMessage = error.error as ErrorMessage;
            this.snackbarService.warning(`Fejl i opdatering af adgangsgrupper: ${errorMessage.message}`);
          }
        },
        next: () => {
          this.snackbarService.success('Adgangsgruppe(r) opdateret på alle ladepunkter');
          this.dialogRef.close();
        },
      });
  }
}
